import { createReducer } from '../../util/createReducer';

export const translations = createReducer({
    translations: {},
} , {
    TRANSLATIONS_LOADED: (state, newTranslations) => ({
        ...state,
        translations: {
            ...state.translations,
            ...newTranslations,
        },
    }),
});
